const state = {
    routeInfo: {
        isBanner: false
    },
    crumbMeta: {}
};

const mutations = {
    SET_RouteInfo(state, value) {
        state.routeInfo.isBanner = value;
    },
    SET_CrumbMeta(state, value) {
        state.crumbMeta = value;
    }
};

const actions = {
    async SET_RouteInfo({ commit }, routeInfo) {
        commit("SET_RouteInfo", routeInfo);
    },
    SET_CrumbMeta({ commit }, crumbMeta) {
        console.log(crumbMeta);
        let routeObj = {};
        switch (crumbMeta) {
            case "news":
                routeObj.title2 = "新闻中心";
                break;
            case "news-detail-id":
                routeObj = {
                    title2: "新闻中心",
                    title3: "新闻详情",
                    link2: "/news"
                };
                break;
            case "document":
                routeObj = {
                    title2: "开放平台",
                    title3: "文档中心",
                    link2: "/openService"
                };
                break;
            case "document-detail-id":
                routeObj = {
                    title2: "开放平台",
                    title3: "文档中心",
                    title4: "文档详情",
                    link2: "/openService",
                    link3: "/document"
                };
                break;
            case "precedent":
                routeObj = {
                    title2: "判例库"
                };
                break;
            case "precedent-detail-id":
                routeObj = {
                    title2: "判例库",
                    title3: "判例详情",
                    link2: "/precedent"
                };
                break;
            case "question":
                routeObj = {
                    title2: "常见问题与帮助中心",
                    parentName: "helpCenter"
                };
                break;
            case "question-detail-id":
                routeObj = {
                    title2: "常见问题与帮助中心",
                    title3: "常见问题详情",
                    link2: "/question",
                    parentName: "helpCenter"
                };
                break;
            case "notice":
                routeObj = {
                    title2: "系统公告"
                };
                break;
            case "notice-detail-id":
                routeObj = {
                    title2: "系统公告",
                    title3: "公告详情",
                    link2: "/notice"
                };
                break;
            case "honor":
                routeObj = {
                    title2: "关于我们",
                    title3: "荣誉资质",
                    link2: "/phoneUs",
                    parentName: "aboutUS"
                };
                break;
            case "tradeMark":
                routeObj = {
                    title2: "关于我们",
                    title3: "商标声明",
                    link2: "/phoneUs",
                    parentName: "aboutUS"
                };
                break;
            case "downLoad":
                routeObj = {
                    title2: "相关下载"
                };
                break;
            case "downLoad-detail-id":
                routeObj = {
                    title2: "相关下载",
                    title3: "协议详情",
                    link2: "/downLoad"
                };
                break;
            case "about":
                routeObj = {
                    title3: "联系我们",
                    title2: "关于我们",
                    link2: "/phoneUs",
                    parentName: "aboutUS"
                };
                break;
            case "guide":
                routeObj = {
                    title2: "常见问题与帮助中心",
                    title3: "操作指引",
                    link2: "/question",
                    parentName: "helpCenter"
                };
                break;
            case "guide-detail-id":
                routeObj = {
                    title2: "常见问题与帮助中心",
                    title3: "操作指引",
                    title4: "操作指引详情",
                    link2: "/question",
                    link3: "/guide",
                    parentName: "helpCenter"
                };
                break;
            case "timingCenter":
                routeObj = {
                    title2: "关于我们",
                    title3: "国家授时中心",
                    link2: "/phoneUs",
                    parentName: "aboutUS"
                };
                break;
            case "sample":
                routeObj = {
                    title2: "时间戳证书样例"
                };
                break;
            case "typicalUser":
                routeObj = {
                    title2: "关于我们",
                    title3: "典型用户",
                    link2: "/phoneUs"
                };
                break;
            case "openService-detail-id":
                routeObj = {
                    title2: "开放平台",
                    title3: "解决方案详情",
                    link2: "/openService"
                };
                break;
            case "partner":
                routeObj = {
                    title2: "关于我们",
                    title3: "典型用户",
                    link2: "/phoneUs",
                    parentName: "aboutUS"
                };
                break;
            case "phoneUs":
                routeObj = {
                    parentName: "aboutUS"
                };
                break;
            case "adobe":
                routeObj = {
                    parentName: "service"
                };
                break;
            case "qlwsDownLoad":
                routeObj = {
                    parentName: "service"
                };
                break;
        }
        commit("SET_CrumbMeta", routeObj);
    }
};

export default {
    state,
    mutations,
    actions
};